export default "__VITE_ASSET__CExxPErf__"